import { SwitchInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { TTicketAutoTransferRuleForm } from "./TicketAutoTransferRuleSchema";

const translationPath = "page.settings.crm.ticketAutoTransferRules.";

export const TransferType = memo(() => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<TTicketAutoTransferRuleForm>();

  const transfer = useWatch({ control, name: "transfer" });
  const endOfDay = useWatch({ control, name: "endOfDay" });

  useEffect(() => {
    if (transfer) {
      setValue("endOfDay", false);
    }
  }, [transfer]);

  useEffect(() => {
    if (endOfDay) {
      setValue("transfer", false);
    }
  }, [endOfDay]);

  return (
    <Grid item xs={12} sm={12}>
      <SwitchInput name="transfer" label={t(translationPath + "transfer")} />
      <SwitchInput name="endOfDay" label={t(translationPath + "end_of_day")} />
    </Grid>
  );
});
